module.exports = __webpack_public_path__ + "img/documents.f34574ff.svg";